<template>
  <div class="contact-table pb-5" id="contact-table">
    <v-simple-table class="table-layout table-contact table-fixed">
      <template v-slot:default>
        <thead>
          <tr>
<!--            <th class="th-# scroll-layout-left th_checkbox" :style="'min-width: 35px;'" ref="th_id">-->
<!--                STT-->
<!--              <div data-v-22d75c44 class="border-bottom-table"></div>-->
<!--            </th>-->
            <th class="th-id scroll-layout-left" :style="'min-width: 40px;'" ref="th_checkbox">
              <v-checkbox
                class="table-layout-checkbox ma-0 pa-0"
                v-model="filterForm.checkboxAll"
                @change="onChangeCheckboxAll"
              />
              <div class="border-bottom-table"></div>
            </th>
            <th
              v-for="(attribute, index) in rowAttributes"
              :key="index + '_th'"
              :ref="'th_' + attribute.name"
              v-show="statusRowAttribute(attribute.name)"
              :class="attribute.sticky ? 'scroll-left' : ''"
            >
              {{attribute.title}}
              <div data-v-22d75c44 class="border-bottom-table"></div>
            </th>
            <th class="th_action">
              Hành động
              <div data-v-22d75c44 class="border-bottom-table"></div>
            </th>
          </tr>
        </thead>
        <tbody
          class="bg-hover"
          :class="contact && contact.callingStatus ? contact.callingStatus : ''"
          :ref="`contact-row-${index}`"
          v-for="(contact, index) in contacts"
          :key="`${contact.id}_${index}`"
        >
          <tr>
<!--            <td class="scroll-layout-left tr-numerical-order" :rowspan="contact.rowspan" style="background-color: #FFFFE5">{{index + 1 + (currentPage - 1)*limit}}</td>-->
            <td
              class="scroll-layout-left"
              :rowspan="contact.rowspan"
            >
              <v-checkbox v-if="contact.transactionStatus === KHONG_XAC_DINH" class="table-layout-checkbox ma-0 pa-0" v-model="contact.checkbox" @change="checkBoxOne"/>
              <div class="border-bottom-table"></div>
            </td>


            <td
                v-for="(attribute, index) in rowAttributes"
                :key="index"
                v-show="statusRowAttribute(attribute.name)"
                :class="attribute.sticky ? 'scroll-left' : ''"
                :style="`background-color: ${_.get(attribute, 'backgroundColor', '')}`"
            >
              <span v-if="attribute.name === 'detail'" ><p>{{_.get(contact, 'phoneNumber', '') || '-'}}</p><p>{{new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(_.get(contact, 'moneyNumber', 0))}}</p></span>
              <span v-else-if="attribute.name === 'orderInfo'" >
                <p>{{_.get(contact, 'receiptCode', '') || '-'}}</p>
                <p>{{_.get(contact, 'orderCode', '') || '-'}}</p>
                <p>{{_.get(contact, 'customerName', '')}}</p>
                <p>{{_.get(contact, 'orderPhone', '')}}</p>
                <p>{{contact.receiptAmount ? getPriceShow(_.get(contact, 'receiptAmount', 0)) : getPriceShow(_.get(contact, 'orderPrice', 0))}}</p>
                <p>{{_.get(contact, 'paymentType', '')}}</p>
              </span>
                <span v-else-if="attribute.name === 'importingSource'" ><p>{{ contact.importingSource ? listImportingSource.find( item => item.code === contact.importingSource).name : '-' }}</p></span>
              <span v-else-if="attribute.name === 'approvedFeedback'" class="user-comment">
                <v-tooltip bottom v-if="_.get(contact, attribute.name, '') && _.get(contact, attribute.name, '').length > 80" max-width="200px">
                  <template v-slot:activator="{ on: tooltip }">
                    <p
                        class="user-comment"
                        v-on="tooltip"
                        style="white-space: pre-line"
                    >
                    {{ _.get(contact, attribute.name, '') || '-' }}
                    </p>
                  </template>
                  <span style="white-space: pre-line">{{ _.get(contact, attribute.name, '') || '-' }}</span>
                </v-tooltip>
                <span style="white-space: pre-line" v-else>{{ _.get(contact, attribute.name, '') || '-' }}</span>
              </span>
              <span class="transaction-status" v-else-if="attribute.name === 'transactionStatus'" :style="`color: ${TRANSACTION_STATUS_COLOR[_.get(contact, 'transactionStatus', '')].color}`">{{TRANSACTION_STATUS_COLOR[_.get(contact, 'transactionStatus', '')].name}}</span>
              <span v-else>{{ _.get(contact, attribute.name, '') || '-' }}</span>
            </td>

            <td class="action-cell" :rowspan="contact.rowspan">
              <div class="action">
                <v-menu offset-y v-if="statusCallCenter && contact.contactType == 'main' && false">
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                          size="16"
                          width="20"
                          height="20"
                          class="mr-1"
                          icon
                          small
                          color="success"
                          v-bind="attrs"
                          v-on="{...tooltip, ...menu}"
                        >
                          <v-icon size="16">mdi-phone</v-icon>
                        </v-btn>
                      </template>
                      <span>Gọi cho khách hàng</span>
                    </v-tooltip>
                  </template>
                  <v-list>
                    <v-list-item
                      @click="clickExecuteCall(contact, _.get(contact, 'studyDate', ''))"
                      class="main-studyDate"
                    >
                      <v-list-item-title>{{_.get(contact, 'studyDate', '')}}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-for="(phone, index) in contact.phoneRelated"
                      :key="index"
                      @click="clickExecuteCall(contact, phone)"
                      class="sub-studyDate"
                    >
                      <v-list-item-title>{{phone}}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-tooltip v-else-if="statusCallCenter && false" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      size="16"
                      width="20"
                      height="20"
                      @click="clickExecuteCall(contact, _.get(contact, 'studyDate', ''))"
                      class="mr-1"
                      icon
                      small
                      color="success"
                      v-on="on"
                    >
                      <v-icon size="16">mdi-phone</v-icon>
                    </v-btn>
                  </template>
                  <span>Gọi cho khách hàng</span>
                </v-tooltip>
                <span v-if="contact.transactionStatus === KHONG_XAC_DINH && checkAuthorization('undefined-reconcile_read')">
                  <v-tooltip bottom >
                    <template v-slot:activator="{ on }">
                      <v-btn
                          class="mr-1"
                          @click="showSelectOrder(contact)"
                          icon
                          medium
                          size="20"
                          width="25"
                          height="25"
                          v-on="on"
                          color="#F2BD00"
                      >
                        <v-icon size="25">mdi-pencil-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>Tìm phiếu thu/ đơn hàng</span>
                  </v-tooltip>
                </span>
                <span v-if="contact.transactionStatus === DA_DOI_SOAT && checkAuthorization('confirmed-reconcile_read')">
                  <v-tooltip bottom >
                    <template v-slot:activator="{ on }">
                      <v-btn
                          class="mr-1"
                          @click="showSelectOrderDDS(contact)"
                          icon
                          medium
                          size="20"
                          width="25"
                          height="25"
                          v-on="on"
                          color="#F2BD00"
                      >
                        <v-icon size="25">mdi-pencil-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>Tìm đơn hàng</span>
                  </v-tooltip>
                </span>
                <span v-if="contact.transactionStatus === CHO_DUYET && checkAuthorization('confirm-bank-order_read')">
                  <v-tooltip bottom v-if="contact.transactionStatus === CHO_DUYET">
                    <template v-slot:activator="{ on }">
                      <v-btn
                          class="mr-1"
                          @click="approvedTransaction(contact.id)"
                          icon
                          medium
                          size="20"
                          width="25"
                          height="25"
                          v-on="on"
                          color="#1890FF"
                      >
                        <v-icon size="25">mdi-check-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>Duyệt</span>
                  </v-tooltip>
                </span>
                <span v-if="contact.transactionStatus === CHO_DUYET && ((checkAuthorization('cancel-bank-order_read') && contact.isOwnByMe) || checkAuthorization('cancel-bank-order_view_all'))">
                  <v-tooltip bottom >
                    <template v-slot:activator="{ on }">
                      <v-btn
                          class="mr-1"
                          @click="openShowReasonNotApprove(contact.id)"
                          icon
                          medium
                          size="20"
                          width="25"
                          height="25"
                          v-on="on"
                          color="#919191"
                      >
                        <v-icon size="25">mdi-close-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>Không duyệt</span>
                  </v-tooltip>
                </span>
                <span v-if="contact.transactionStatus === DA_XU_LY && checkAuthorization('reconcile-sms_view_all')">
                  <v-tooltip bottom >
                    <template v-slot:activator="{ on }">
                      <v-btn
                          class="mr-1"
                          @click="changeTransactionStatus(contact, KHONG_XAC_DINH)"
                          icon
                          medium
                          size="20"
                          width="25"
                          height="25"
                          v-on="on"
                          color="#919191"
                      >
                        <v-icon size="25">mdi-plus-circle-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Chuyển KXĐ</span>
                  </v-tooltip>
                </span>
                <span v-if="contact.transactionStatus === KHONG_XAC_DINH && checkAuthorization('reconcile-sms_view_all')">
                  <v-tooltip bottom >
                    <template v-slot:activator="{ on }">
                      <v-btn
                          class="mr-1"
                          @click="openNoteChangeStatus(contact)"
                          icon
                          medium
                          size="20"
                          width="25"
                          height="25"
                          v-on="on"
                          color="#919191"
                      >
                        <v-icon size="25">mdi-minus-circle-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Đã xử lý</span>
                  </v-tooltip>
                </span>
                <span>
                  <v-tooltip bottom >
                    <template v-slot:activator="{ on }">
                      <v-btn
                          class="mr-1"
                          @click="openLogHistories(contact)"
                          icon
                          medium
                          size="20"
                          width="25"
                          height="25"
                          v-on="on"
                          color="#919191"
                      >
                        <v-icon size="23">mdi-file-clock</v-icon>
                      </v-btn>
                    </template>
                    <span>Lịch sử hoạt động</span>
                  </v-tooltip>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-if="contacts.length == 0">
          <tr>
            <td colspan="10" class="scroll-layout-left">
              <common-no-result />
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div v-if="isShowdetail">
      <ModalShowDetailKXD
          @close-modal="closeShowDetailOrder"
          :selectedRecord="selectedRecord"
          :filter-form="filterForm"
      />
    </div>
    <ModalShowDetailDDS
      v-if="isShowdetailDDS"
      @close-modal="closeShowDetailOrderDDS"
      :selectedRecord="selectedRecord"
      :filter-form="filterForm"
    />
    <div v-if="isShowReasonNotApprove">
      <modal-approved
        :isOpenPopupApprove="isShowReasonNotApprove"
        :titlePopup="'Lý do không phê duyệt'"
        :placeholderPopup="'Nhập lý do'"
        :contactChoose="selectedRecordToNotApproved"
        @confirmApproved="deniedTransaction"
        @closeModal="closeShowReasonNotApprove"
      />
    </div>

    <div v-if="isPopupNote">
      <modal-approved
          :isOpenPopupApprove="isPopupNote"
          :titlePopup="'Ghi chú'"
          :placeholderPopup="'Nhập ghi chú'"
          :contactChoose="transactionChoose"
          @confirmApproved="checkApprovedFeedbackNote"
          @closeModal="closeModalApproveNote"
      />
    </div>

    <div v-if="isOpenPopupHistoryLog">
      <v-dialog
          :value="true"
          max-width="580"
          persistent
          @click:outside="isOpenPopupHistoryLog = false"
      >
        <div class="popup-history-logs">
          <div class="popup-history-logs-title">Nhật ký hoạt động</div>
          <v-divider />
          <div class="popup-history-logs-body">
            <p v-for="(record, i) in listHistoryLogsTransactionSelected" :key="i" v-html="record.actionContent"></p>
          </div>
          <div class="popup-history-logs-action">
            <v-btn
                color="#D9D9D9"
                @click="isOpenPopupHistoryLog = false"
                height="40px"
                style="color: black;text-transform: unset !important;"
            >Đóng</v-btn>
          </div>
        </div>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import TokenService from "@/helpers/token";
import handleSchedule from "@/mixins/handleSchedule";
import { userPositions, regex } from '@/helpers/constants';
import { TRANSACTION_STATUS_COLOR, DA_DOI_SOAT, CHO_DUYET, KHONG_XAC_DINH, DA_XU_LY } from "@/helpers/constants";
import ModalShowDetailKXD from "@/pages/order-payment-checklist/components/ModalShowDetailKXD";
import ModalShowDetailDDS from "@/pages/order-payment-checklist/components/ModalShowDetailDDS";
import RepositoryFactory from "@/repositories/RepositoryFactory";
import ModalApproved from "./ModalApproved";
const OrderRepository = RepositoryFactory.get('order');

export default {
  $_veeValidate: {
    validator: "new",
  },
  components:{
    ModalShowDetailKXD,
    ModalApproved,
    ModalShowDetailDDS,
  },
  mixins: [handleSchedule],
  props: {
    filterForm: {
      type: Object,
      default: () => ({})
    },
    mapStatusCode: {
      type: Object,
      default: () => ({})
    },
    contacts: {
      type: Array,
      default: () => []
    },
    rowAttributes: {
      type: Array,
      default: () => []
    },
    users: {
      type: Array,
      default: () => []
    },
    distributionStatus: {
      type: Array,
      default: () => []
    },
    currentPage: {
      type: Number,
      default: () => 0
    },
    limit: {
      type: Number,
      default: () => 50
    },
  },
  data() {
    return {
      dataContact: {},
      studyDate: '',
      oldPosition: 0,
      snackbar: false,
      valid: true,
      user: {},
      userPositions,
      regex,
      isShowdetail: false,
      isShowdetailDDS: false,
      isShowReasonNotApprove: false,
      selectedRecord: {
        code: '',
        package:'',
        receiver: '',
        phone: '',
        totalPrice: '',
        userFullName: '',
        totalPriceShow:'',
        orderId: 0,
        transactionId: 0,
        transactionStatus: '',
        paymentType: '',
        products: [],
        combos: [],
        originOrderCode:'',
      },
      selectedRecordToNotApproved:{
        comment: '',
        transactionId: 0,
      },
      TRANSACTION_STATUS_COLOR,
      CHO_DUYET,
      DA_DOI_SOAT,
      KHONG_XAC_DINH,
      DA_XU_LY,
      isPopupNote: false,
      transactionChoose: {
        id: null,
        comment: '',
      },
      isOpenPopupHistoryLog: false,
      listHistoryLogsTransactionSelected: [],
      listImportingSource: [
          { code: "SAO_KE", name: 'Sao kê'},
          { code: "SMS", name: 'SMS'},
      ],
    };
  },
  created() {
    this.user = TokenService.getUser();
  },
  computed: {
    statusCallCenter() {
      return (
        this.checkAuthorization('call_center_read') ||
        this.checkAuthorization('call_center_view_all')
      );
    },
    countContactSelect() {
      return this.contacts.filter((dataContact) => dataContact.checkbox).length;
    },
  },
  methods: {
    closeShowDetailOrder(){
      this.selectedRecord = {
        code: '',
        package:'',
        receiver: '',
        phone: '',
        totalPrice: '',
        userFullName: '',
        totalPriceShow: '',
        orderId: 0,
        transactionId: 0,
        transactionStatus: '',
        paymentType: '',
        products: [],
        combos: [],
        originOrderCode:'',
      }
      this.isShowdetail = false
    },
    closeShowDetailOrderDDS(){
      this.selectedRecord = {
        code: '',
        package:'',
        receiver: '',
        phone: '',
        totalPrice: '',
        userFullName: '',
        totalPriceShow: '',
        orderId: 0,
        transactionId: 0,
        transactionStatus: '',
        paymentType: '',
        products: [],
        combos: [],
        originOrderCode:'',
      }
      this.isShowdetailDDS = false
    },
    statusRowAttribute(attributeName) {
      return (
        this.rowAttributes.findIndex(
          attribute => attribute.value && attribute.name == attributeName
        ) !== -1
      );
    },
    getPriceShow(price){
      if (!price){
        return ''
      }
      return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(price)
    },
    clickExecuteCall(contact, phone) {
      let user = TokenService.getUser()
      if (user.ext) {
        let data = {
          studyDate: phone,
          showCreateAppointment: false,
          contactId: contact.id,
          callcenter_id: user.callcenter_id,
          mainId: contact.mainId,
          mainstudyDate: contact.phoneRelated[0],
          store: this.filterForm.store
        }
        Bus.$emit('voice-call-show-popup', data)
      } else {
        this.$swal({
          title: 'Thông báo!',
          text: 'Chưa có máy lẻ. Vui lòng liên hệ Admin.'
        })
      }
    },
    onChangeCheckboxAll() {
      this.contacts.forEach(contact => {
        const contactTemp = contact;
        if(contactTemp.transactionStatus === this.KHONG_XAC_DINH){
          contactTemp.checkbox = this.filterForm.checkboxAll && !contact.mainId;
        }
      });
    },
    checkBoxOne() {
      const changeContactList = this.contacts.filter(
          contact => contact.checkbox
      );
      const totalElementHasCheckbox = this.contacts.filter(
          contact => contact.transactionStatus === this.KHONG_XAC_DINH
      );
      if(changeContactList?.length === totalElementHasCheckbox.length){
        this.filterForm.checkboxAll = true;
      }else{
        this.filterForm.checkboxAll = false;
      }
    },
    async showSelectOrder(contact) {
      this.selectedRecord.code = contact.receiptCode;
      this.selectedRecord.transactionId = contact.id;
      // this.selectedRecord.originOrderCode = contact.receiptCode;
      // if(this.selectedRecord.code){
      //   const res = await OrderRepository.getOrderDetailByCode(this.selectedRecord.code)
      //   if(res?.data?.data?.length > 0) {
      //     let totalPriceShow = res.data.data[0].totalPrice.toLocaleString('it-IT', {
      //       style: 'currency',
      //       currency: 'VND'
      //     });
      //     this.selectedRecord.receiver = res.data.data[0].receiver;
      //     this.selectedRecord.phone = res.data.data[0].phone;
      //     this.selectedRecord.totalPrice = res.data.data[0].totalPrice;
      //     this.selectedRecord.totalPriceShow = totalPriceShow;
      //     this.selectedRecord.userFullName = res.data.data[0].user.fullName;
      //     this.selectedRecord.orderId = res.data.data[0].id;
      //     this.selectedRecord.paymentType = res.data.data[0].paymentType;
      //     this.selectedRecord.products = res.data.data[0].products;
      //     this.selectedRecord.combos = res.data.data[0].combos;
      //   }else{
      //     this.$swal({
      //       title: 'Đơn hàng không tồn tại !!!',
      //     })
      //   }
      // }
      // this.selectedRecord.transactionId = contact.id;
      // this.selectedRecord.transactionStatus = contact.transactionStatus;
      this.isShowdetail = true
    },
    async showSelectOrderDDS(contact) {
      this.selectedRecord.code = contact.receiptCode;
      this.selectedRecord.transactionId = contact.id;
      // this.selectedRecord.code = contact.orderCode;
      // this.selectedRecord.originOrderCode = contact.orderCode;
      // if(this.selectedRecord.code){
      //   const res = await OrderRepository.getOrderDetailByCode(this.selectedRecord.code)
      //   if(res?.data?.data?.length > 0) {
      //     let totalPriceShow = res.data.data[0].totalPrice.toLocaleString('it-IT', {
      //       style: 'currency',
      //       currency: 'VND'
      //     });
      //     this.selectedRecord.receiver = res.data.data[0].receiver;
      //     this.selectedRecord.phone = res.data.data[0].phone;
      //     this.selectedRecord.totalPrice = res.data.data[0].totalPrice;
      //     this.selectedRecord.totalPriceShow = totalPriceShow;
      //     this.selectedRecord.userFullName = res.data.data[0].user.fullName;
      //     this.selectedRecord.orderId = res.data.data[0].id;
      //     this.selectedRecord.paymentType = res.data.data[0].paymentType;
      //     this.selectedRecord.products = res.data.data[0].products;
      //     this.selectedRecord.combos = res.data.data[0].combos;
      //   }else{
      //     this.$swal({
      //       title: 'Đơn hàng không tồn tại !!!',
      //     })
      //   }
      // }
      // this.selectedRecord.transactionId = contact.id;
      // this.selectedRecord.transactionStatus = contact.transactionStatus;
      this.isShowdetailDDS = true
    },
    async approvedTransaction(transactionId){
       const res = await OrderRepository.approvedTransaction(transactionId)
       if(res?.success){
         this.$swal({
           type: 'success',
           icon: 'success',
           timer: 2000,
           showConfirmButton: false,
           title: 'Thao tác thành công !!!',
         })
         Bus.$emit('contact-list-filter', this.filterForm);
       }else{
         this.$swal({
           type: 'error',
           title: 'Thông báo !',
           text: 'Thao tác không thành công !!!'
         });
       }
    },
    async deniedTransaction(){
      if(!this.selectedRecordToNotApproved?.comment){
        this.$swal({
          title: 'Vui lòng nhập lý do.'
        })
        return
      }
      const res = await OrderRepository.deniedTransaction(this.selectedRecordToNotApproved)
      if(res?.success){
        this.$swal({
          type: 'success',
          icon: 'success',
          timer: 2000,
          showConfirmButton: false,
          title: 'Thao tác thành công !!!',
        })
        this.closeShowReasonNotApprove()
        Bus.$emit('contact-list-filter', this.filterForm);
      }else{
        this.$swal({
          type: 'error',
          title: 'Thông báo !',
          text: 'Thao tác không thành công !!!'
        });
      }
    },
    openShowReasonNotApprove(transactionId){
      this.selectedRecordToNotApproved.transactionId = transactionId;
      this.isShowReasonNotApprove = true
    },
    closeShowReasonNotApprove(){
      this.selectedRecordToNotApproved = {
        comment: '',
        transactionId: 0,
      };
      this.isShowReasonNotApprove = false
    },
    openNoteChangeStatus(contact) {
      this.isPopupNote = true;
      this.transactionChoose.id = contact.id;
    },
    closeModalApproveNote() {
      this.isPopupNote = false;
      this.transactionChoose = {
        id: null,
        comment: '',
      };
    },
    checkApprovedFeedbackNote(e) {
      if (e.comment) {
        this.changeTransactionStatus(e, this.DA_XU_LY);
        return;
      }
      this.$swal({
        type: 'error',
        icon: 'error',
        timer: 2000,
        title: 'Bắt buộc phải nhập ghi chú!',
      });
    },
    async changeTransactionStatus(transaction, statusId){
      const body = {
        statusId: statusId,
        transactionId: transaction.id,
        approvedFeedback: transaction.comment,
      }
      const res = await OrderRepository.changeTransactionStatus(body)
      if(res?.success){
        this.$swal({
          type: 'success',
          icon: 'success',
          timer: 2000,
          showConfirmButton: false,
          title: 'Thao tác thành công !!!',
        })
        Bus.$emit('contact-list-filter', this.filterForm);
        this.closeModalApproveNote();
      }else{
        this.$swal({
          type: 'error',
          title: 'Thông báo !',
          text: res?.errors?.message ?? 'Thao tác không thành công !!!'
        });
      }
    },
    async openLogHistories(transaction){
      const loading = this.$loading.show()
      const res = await OrderRepository.getListHistoryLogs(transaction.id)
      loading.hide();
      if(res.success){
        this.listHistoryLogsTransactionSelected = res.data
      }
      this.isOpenPopupHistoryLog = true;
    }
  },
};
</script>

<style scoped>
.table-contact tbody tr {
  height: 50px;
}
.table-contact table {
  border: 1px solid #d2d2d2;
}
.table-contact table .bg-hover:hover .child-table td:last-child {
  background: #e0e0e0;
}
.table-contact table .bg-hover:hover tr .scroll-layout-left {
  background: #e0e0e0;
}
.table-contact table .in-call tr {
  background: #90EE90;
}
.table-contact table .in-call tr .scroll-layout-left{
  background: #90EE90;
}
.table-contact table .calling tr {
  background: #FA8072;
}
.table-contact table .calling tr .scroll-layout-left{
  background: #FA8072;
}
.table-contact thead tr {
  height: 35px;
}
.table-contact thead th {
  border-right: 1px solid #d2d2d2;
  font-size: 14px !important;
}
.table-contact thead th:last-child {
  border-right: 0;
}
.table-contact thead .th-id {
  min-width: 50px;
}
.table-contact .child-table td:last-child {
  border-right: 1px solid #d2d2d2;
}
.table-contact .child-table:hover {
  background: rgba(0, 0, 0, 0.11) !important;
}
.table-contact td {
  position: relative;
  border-right: 1px solid #d2d2d2;
  font-size: 14px !important;
  color: #000000;
}
.table-contact td:last-child {
  border-right: 0;
}
.table-contact .table-layout-checkbox {
  position: relative;
}
.table-contact .table-layout-checkbox .v-input--selection-controls__input {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.v-data-table td {
  font-weight: 400;
  padding: 12px 8px;
  color: #444;
}

/deep/ tbody td {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  text-align: left;
  font-size: 15px !important
}

tbody .action-cell {
  text-align: center;
}

tbody .tr-numerical-order {
  text-align: center;
}

thead th {
  height: 30px;
}


.scroll-left {
  /* position: fixed; */
  position: sticky;
  background: #fff;
  border-left: 1px solid #d2d2d2!important;
}

td.scroll-left {
  z-index: 1;
}
/deep/ .v-data-table--fixed-header > .v-data-table__wrapper > table > thead > tr > th.scroll-left {
  border-bottom: 0px !important;
  position: sticky;
  top: 0;
  z-index: 3;
}

/deep/ .table-layout-checkbox .v-input--selection-controls__input {
  z-index: 1;
}
/deep/.th_teacher {
  min-width: 170px;
}
/deep/.th_parentFullName {
  min-width: 170px;
}
/deep/.th_description {
  min-width: 200px;
}
/deep/.th_user {
  min-width: 170px;
}
/deep/.th_email {
  min-width: 150px;
}
/deep/.th_detailAddress {
  min-width: 250px;
}

/deep/ .th_productDescription {
  max-width: 250px;
}

/deep/ .th_numberOfCall {
  max-width: 20px;
}

/deep/ .th_appointment {
  min-width: 200px;
}

.appointment-time-wrapper {
  padding: 2px 0px;
  border: thin solid #A9A9A9;
  border-radius: 5px;
  cursor: pointer;
  min-width: 140px;
}
.custom-span-title-study-result {
  color: black;
  font-size: 13px !important;
  text-transform: none !important;
}
/deep/ .btn-show-modal-study-result span.v-btn__content {
  justify-content: normal !important;
}
.icon-comment {
  margin-left: 5px;
}
.btn-show-modal-count-interaction {
  position: absolute;
  top: 20%;
  right: 0%;
}

/deep/ .v-text-field--is-booted .v-input__control .v-input__slot {
  border: 1px solid #d9dbe9 !important;
  height: 40px !important;
  padding: 0 12px !important;
  border-radius: 4px !important;
}
/deep/ .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: #d9dbe9 !important;
}
/deep/ .v-text-field--is-booted {
  padding-top: unset !important;
  margin-top: unset !important;
}
/deep/
  .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
  > .v-input__control
  > .v-input__slot
  fieldset {
  border: 1px !important;
}
.trail-tag {
  padding: 0px 6px;
  font-weight: 400;
  display: inline-block;
  width: 32px;
  text-align: center;
}
.tn-tag-trial {
  color: #219653;
  border: 1px solid #219653;
}
.ch-tag-trial {
  color: #F2994A;
  border: 1px solid #F2994A;
}
.v-tag-trial {
  color: #4F4F4F;
  border: 1px solid #4F4F4F;
}
@media screen and (max-width: 767px) {
  /deep/ .scroll-layout-left {
    position: unset !important;
  }
  /deep/ .th_studyDate, .th_studyHour, .th_teacher, .th_checkbox, .th-id {
    position: sticky !important;
    left: unset !important;
  }
}
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: unset;
}
.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background: #94bdf6 !important;
}
.v-input--radio-group.v-input--radio-group--row .v-radio {
  margin-right: 8px !important;
}
.trail-tag {
  padding: 0px 6px;
  font-weight: 400;
  display: inline-block;
  width: 32px;
  text-align: center;
}
.tn-tag-trial {
  color: #219653;
  border: 1px solid #219653;
}
.ch-tag-trial {
  color: #f2994a;
  border: 1px solid #f2994a;
}
.v-tag-trial {
  color: #4f4f4f;
  border: 1px solid #4f4f4f;
}
</style>

<style scoped lang="scss">
.popup-history-logs{
  min-height: 297px;
  background: #FFFFFF;
  .popup-history-logs-title{
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
    padding: 30px 0px 21px 22px;
  }
  .popup-history-logs-body{
    width: 530px;
    min-height: 252px;
    border: 0.5px solid #000000;
    margin: 0px 0px 20px 24px;
    padding: 16px;
    overflow: auto;
    p{
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
    }
  }
  .popup-history-logs-action{
    display: flex;
    justify-content: center;
    padding-bottom: 15px;
    margin-left: 17px;
  }
}
.table-contact {
  .transaction-status{
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 16px;
  }
  .user-comment {
    -webkit-line-clamp: 3;
    overflow: hidden;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    max-width: 200px;
  }
}
</style>
